import Helper from "@ember/component/helper"
import { htmlSafe } from "@ember/template"

export function jsonStringify(params) {
  let doc = params[0]
  // return Ember.String.htmlSafe(`<pre><code class="language-json">${JSON.stringify(doc, null, 1)}</code></pre>`)
  let text
  try {
    text = Prism.highlight(JSON.stringify(doc, null, 1), Prism.languages.json)
  } catch (e) {
    console.log("e", e)
  }
  return htmlSafe(`<pre><code>${text}</code></pre>`)
}

export default class JsonStringify extends Helper {
  compute = jsonStringify
}
